import React, { useEffect, useState } from 'react';
import LocalLibraryIcon from '@material-ui/icons/LocalLibrary';
import GeneralLayout from '../landingGeneral/generalLayout';
import { useListParams } from 'react-admin';

const WinLandingLayout = (props: any) => {
  return <GeneralLayout {...props} pageType='WIN' />;
};
const DiscountLandingLayout = (props: any) => {
  return <GeneralLayout {...props} pageType='DISCOUNT' />;
};
const TheSunLandingLayout = (props: any) => {
  return <GeneralLayout {...props} pageType='THESUN' />;
};
const DealLandingLayout = (props: any) => {
  return <GeneralLayout {...props} pageType='DEAL' />;
};
const OfferLandingLayout = (props: any) => {
  return <GeneralLayout {...props} pageType='OFFER' />;
};
const DynamicandingLayout = (props: any) => {
  const [type, setType] = useState('');
  const params = props.match.params;
  useEffect(() => {
    const params = props.match.params;
    console.log('params: ', params);
    const pageType = params.type ? params.type.toUpperCase() : '';
    setType(pageType);
  }, [props.match.params]);
  if (!type) {
    return null;
  }
  return <GeneralLayout {...props} pageType={type} />;
};

let landingGeneral = (type: string) => {
  switch (type) {
    case 'DYNAMIC': {
      return {
        list: DynamicandingLayout,
        icon: LocalLibraryIcon,
      };
    }
    case 'WIN': {
      return {
        list: WinLandingLayout,
        icon: LocalLibraryIcon,
      };
    }
    case 'DISCOUNT': {
      return {
        list: DiscountLandingLayout,
        icon: LocalLibraryIcon,
      };
    }
    case 'THESUN': {
      return {
        list: TheSunLandingLayout,
        icon: LocalLibraryIcon,
      };
    }
    case 'DEAL': {
      return {
        list: DealLandingLayout,
        icon: LocalLibraryIcon,
      };
    }
    case 'OFFER': {
      return {
        list: OfferLandingLayout,
        icon: LocalLibraryIcon,
      };
    }
    default: {
      return {
        list: WinLandingLayout,
        icon: LocalLibraryIcon,
      };
    }
  }
};

export { landingGeneral };
